// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* .column-title {\n\tmin-height: auto;\n\tmargin-top: 2.5em;\n} */\n.chart[data-v-d24689f4] {\n\tmax-height: 600px;\n}\n.no-border[data-v-d24689f4] {\n\tborder: none !important;\n\tbox-shadow: none;\n\tpadding-left: 0;\n\tpadding-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
